import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {Measure} from '../../workingdata/message/Measure';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {VisionFilterKey} from './VisionFilterKey';
import {VisionKey} from './VisionKey';
import {VisionStep} from './VisionStep';
import {VisionStepPerimeter} from './VisionStepPerimeter';

export class Vision extends BasicEntity {
autoCompute: boolean | null;
chronoCode: string;
code: string;
color: string;
computeCron: string;
dataMode: string;
description: TranslatedEmb;
helpURL: string;
icon: string;
label: TranslatedEmb;
measures: Measure[];
minRevNumber: number | null;
navigationMode: string;
runMode: string;
settings: Object;
status: string;
supportMail: string;
themeCode: string;
useCompute: boolean | null;
usePdfExport: boolean | null;
useScenario: boolean | null;
visionFilterKeys: {[key: string]: VisionFilterKey};
visionKeys: {[key: string]: VisionKey};
visionStepPerimeters: {[key: string]: VisionStepPerimeter};
visionSteps: {[key: string]: VisionStep};
}

